/**
 * French Canadian price formatting for the French storefront.
 *
 * Runs only on French-locale pages (detected via <html lang="fr...">).
 *
 * Does three things:
 *  1. Overrides Shopify.formatMoney so all JS-driven price updates
 *     (variant switching, RTX subscription widget, etc.) use fr-CA format.
 *  2. Reformats Rebuy widget prices (.rebuy-money elements) which use
 *     their own internal formatting and bypass Shopify.formatMoney.
 *  3. Watches for Rebuy widgets loaded asynchronously via MutationObserver.
 *
 * fr-CA convention: "14,99 $ CA"  (comma decimal, symbol after, CA suffix)
 */
(function () {
  if (!document.documentElement.lang.startsWith('fr')) return;

  /**
   * Format a raw cent amount as a French Canadian price string.
   * @param {number|string} cents
   * @returns {string}
   */
  function formatPriceFR(cents) {
    if (typeof cents === 'string') {
      cents = parseInt(cents.replace(/[^0-9]/g, ''), 10);
    }
    if (isNaN(cents) || cents == null) return '';

    var dollars = Math.floor(cents / 100);
    var remainder = cents % 100;
    var centsStr = remainder < 10 ? '0' + remainder : '' + remainder;
    var dollarsFormatted = dollars
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0'); // thousands: non-breaking space

    return dollarsFormatted + ',' + centsStr + '\u00A0$\u00A0CA';
  }

  /**
   * Reformat any .rebuy-money elements that are still in English format.
   * Rebuy outputs prices like "$14.99" or "$1,234.56 CAD" — we parse those
   * and replace the text with the fr-CA equivalent.
   * @param {Document|Element} root
   */
  function reformatRebuePrices(root) {
    (root || document).querySelectorAll('.rebuy-money').forEach(function (el) {
      var text = el.textContent.trim();

      // Already in French format if it contains comma-decimal (e.g. "14,99")
      if (/\d,\d{2}/.test(text)) return;

      // Extract digits, periods, and commas — strip currency symbols and letters
      var numStr = text.replace(/[^0-9.,]/g, '');
      if (!numStr) return;

      // English format uses period as decimal and comma as thousands separator.
      // Remove thousands commas: a comma followed by exactly 3 digits then
      // either another comma, a period, or end-of-string is a thousands separator.
      var cleaned = numStr.replace(/,(?=\d{3}(?:[,.]|$))/g, '');
      var dollars = parseFloat(cleaned);
      if (isNaN(dollars)) return;

      el.textContent = formatPriceFR(Math.round(dollars * 100));
    });
  }

  // ── 1. Override Shopify.formatMoney ──────────────────────────────────────
  function applyFormatMoneyOverride() {
    window.Shopify = window.Shopify || {};
    window.Shopify.formatMoney = formatPriceFR;
  }

  // ── 2. MutationObserver for async Rebuy widgets ──────────────────────────
  function startRebuyObserver() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      var hasAdditions = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasAdditions) reformatRebuePrices(document);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    applyFormatMoneyOverride();
    reformatRebuePrices(document);
    startRebuyObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
